import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faBell, faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { getNotificationTranlation } from "../../utilities/utils";
import SubscriptionCheckBox from "./subscriptionCheckBox";

const SubscriptionCategoryTable = ({
  categoryName,
  triggers,
  subscriptionStatus,
  handleCheckboxChange,
  showHeader,
}) => {
  const { t } = useTranslation("common");

  const iconMap = [
  { icon: faEnvelope, titleKey: "emailNotification" },
  { icon: faBell, titleKey: "inAppBadgeNotification" },
  { icon: faMobileScreenButton, titleKey: "pwaPushNotification" },
];

  return (
    <table>
      <thead>
        <tr>
          <th style={{ width: "7vw" }}>
            {showHeader ? t("SUBSCRIPTIONMANAGEMENT.categoryName") : ""}
          </th>
          <th style={{ width: "10vw" }}>
            {showHeader ? t("SUBSCRIPTIONMANAGEMENT.triggerType") : ""}
          </th>
          {iconMap.map(({ icon, titleKey }) => (
            <th style={{ width: "3vw" }} key={titleKey}>
              {showHeader ? (
                <span title={t(`SUBSCRIPTIONMANAGEMENT.${titleKey}`)}>
                  <FontAwesomeIcon icon={icon} />
                </span>
              ) : ""}
              </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {triggers.map((item, index) => (
          <tr key={item.triggerType}>
            <td>
              {index === 0 ? getNotificationTranlation(t, categoryName) : ""}
            </td>
            <td> {getNotificationTranlation(t, item.triggerType)}</td>
            {["Email", "InApp", "PwaPush"].map((type) => (
              <td key={type}>
                <SubscriptionCheckBox
                  subscriptionStatus={subscriptionStatus}
                  triggerType={item.triggerType}
                  type={type}
                  handleCheckboxChange={handleCheckboxChange}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SubscriptionCategoryTable;
